/* ==========================================================================
   AMARA · movimiento
   Entrada al hacer scroll, trazo de la línea del tiempo y pulso del
   contador del carrito.

   Dos reglas que vienen del moodboard y conviene no perder de vista:
   solo entra lo que abre una idea —antetítulo, titular, entradilla—, y
   nada se mueve dos veces.

   El atributo que esconde los elementos lo pone este script, así que sin
   JavaScript no queda nada invisible.
   ========================================================================== */

(function () {
  'use strict';

  var QUIETAS = ['amara-header', 'amara-footer', 'amara-marquee', 'amara-product-bar', 'amara-hero'];

  function esQuieta(seccion) {
    // El héroe no se escalona al cargar: entra con la página o no entra.
    return QUIETAS.some(function (t) { return seccion.querySelector('.' + t.replace('amara-', 'am-')) || seccion.className.indexOf(t) > -1; });
  }

  function anclas(seccion) {
    // El antetítulo, el primer titular y el párrafo que lo sigue.
    var salida = [];
    var eyebrow = seccion.querySelector('.am-eyebrow');
    var titulo = seccion.querySelector('h1.am-display, h2.am-display');
    if (eyebrow && (!titulo || eyebrow.compareDocumentPosition(titulo) & Node.DOCUMENT_POSITION_FOLLOWING)) salida.push(eyebrow);
    if (titulo) salida.push(titulo);
    if (titulo) {
      var sig = titulo.nextElementSibling;
      // Solo si lo que sigue es texto, no una retícula ni una imagen.
      if (sig && /^(P|DIV)$/.test(sig.tagName) && sig.children.length <= 1 && sig.textContent.trim().length > 20) {
        salida.push(sig);
      }
    }
    return salida;
  }

  function preparar() {
    var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducido || !('IntersectionObserver' in window)) return;

    // Si por lo que sea la ventana mide 0, mejor no esconder nada.
    var alto = window.innerHeight || 10000;
    var observador = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        observador.unobserve(e.target);   // una vez, nunca en cada pasada
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.01 });

    [].forEach.call(document.querySelectorAll('.shopify-section'), function (seccion) {
      if (esQuieta(seccion)) return;
      anclas(seccion).forEach(function (el, i) {
        if (el.hasAttribute('data-am-reveal')) return;
        el.setAttribute('data-am-reveal', '');
        el.style.setProperty('--am-reveal-delay', (i * 70) + 'ms');

        // Lo que ya se ve al cargar no se anima: aparece y punto.
        if (el.getBoundingClientRect().top < alto * 0.9) {
          el.classList.add('is-instant');
        } else {
          observador.observe(el);
        }
      });
    });
  }

  /* --- línea del tiempo -------------------------------------------------- */

  // Cada etapa dibuja su tramo cuando asoma un 15 %. Igual que las entradas:
  // si la línea ya se ve al cargar, se queda puesta, y en el editor de temas
  // tampoco se arma, para que al colocar las imágenes se vea completa.
  function trazar() {
    var tableros = document.querySelectorAll('[data-am-etapas]');
    if (!tableros.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;
    if (window.Shopify && window.Shopify.designMode) return;

    var alto = window.innerHeight || 10000;
    var observador = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-drawn');
        observador.unobserve(e.target);
      });
    }, { threshold: 0.15 });

    [].forEach.call(tableros, function (tablero) {
      if (tablero.classList.contains('is-armed')) return;
      if (tablero.getBoundingClientRect().top < alto * 0.9) return;
      tablero.classList.add('is-armed');
      [].forEach.call(tablero.children, function (etapa) { observador.observe(etapa); });
    });
  }

  /* --- pulso del contador ------------------------------------------------ */

  var ultimo = null;

  function pulso() {
    var burbuja = document.querySelector('.cart-count-bubble');
    if (!burbuja) { ultimo = 0; return; }
    var n = parseInt(burbuja.textContent, 10);
    if (isNaN(n)) return;
    if (ultimo !== null && n !== ultimo) {
      burbuja.classList.remove('is-ticking');
      void burbuja.offsetWidth;              // reinicia la animación
      burbuja.classList.add('is-ticking');
    }
    ultimo = n;
  }

  document.addEventListener('amara:cart:updated', function () { setTimeout(pulso, 30); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { preparar(); trazar(); pulso(); });
  } else {
    preparar(); trazar(); pulso();
  }
})();
